import { Injectable } from '@angular/core';
import { MongoService } from '../services/mongo.service';
import { ExcelReaderService } from './excel-reader.service';

@Injectable({
  providedIn: 'root'
})
export class UsersContactsLoaderService {

  constructor(
    private excelReader: ExcelReaderService,
    private mongoService: MongoService
  ) { }

  public async executeUsersContactsDataReplacement(excelFile: any) : Promise<boolean>{
    try {
      const contactsData = await this.excelReader.parseExcelFileNoDatesFormat(excelFile);
      const contactsArr = await this.createContactsArray(contactsData);
      if (contactsArr.length > 0) {
        await this.mongoService.deleteUsersContactsData();

        const [tab1, tab2] = await this.splitTable(contactsArr);

        const [tab11, tab12] = await this.splitTable(tab1);
        const [tab21, tab22] = await this.splitTable(tab2);
    
        const [tab111, tab112] = await this.splitTable(tab11);
        const [tab121, tab122] = await this.splitTable(tab12);
        const [tab211, tab212] = await this.splitTable(tab21);
        const [tab221, tab222] = await this.splitTable(tab22);
    
        const [tab1111, tab1112] = await this.splitTable(tab111);
        const [tab1121, tab1122] = await this.splitTable(tab112);
        const [tab1211, tab1212] = await this.splitTable(tab121);
        const [tab1221, tab1222] = await this.splitTable(tab122);
        const [tab2111, tab2112] = await this.splitTable(tab211);
        const [tab2121, tab2122] = await this.splitTable(tab212);
        const [tab2211, tab2212] = await this.splitTable(tab221);
        const [tab2221, tab2222] = await this.splitTable(tab222);

        await this.mongoService.setUsersContactsData(tab1111);
        await this.mongoService.setUsersContactsData(tab1112);
        await this.mongoService.setUsersContactsData(tab1121);
        await this.mongoService.setUsersContactsData(tab1122);
        await this.mongoService.setUsersContactsData(tab1211);
        await this.mongoService.setUsersContactsData(tab1212);
        await this.mongoService.setUsersContactsData(tab1221);
        await this.mongoService.setUsersContactsData(tab1222);
        await this.mongoService.setUsersContactsData(tab2111);
        await this.mongoService.setUsersContactsData(tab2112);
        await this.mongoService.setUsersContactsData(tab2121);
        await this.mongoService.setUsersContactsData(tab2122);
        await this.mongoService.setUsersContactsData(tab2211);
        await this.mongoService.setUsersContactsData(tab2212);
        await this.mongoService.setUsersContactsData(tab2221);
        await this.mongoService.setUsersContactsData(tab2222);
        return true;
      }
      else {
        return false;
      }
    } catch (e) {
      console.error(e);
      console.error('Wystąpił błąd podczas wczytywania listy danych teleadresowych');
      return false;
    }
  }

  private async createContactsArray(data:any): Promise<any>{
    let contactsArr:Array<any> = []
    data.forEach((dataRow:any) => contactsArr.push({
      userEmail: dataRow.userEmail,
      firstName: dataRow.firstName,
      lastName: dataRow.lastName,
      companyName: dataRow.companyName,
      nipCode: dataRow.nipCode,
      phoneNumber: dataRow.phoneNumber,
      streetName: dataRow.streetName,
      buildingNumber: dataRow.buildingNumber,
      city: dataRow.city,
      postalCode: dataRow.postalCode,
      voivodeship: dataRow.voivodeship,
    }));
    return contactsArr;
  }

  async splitTable(tablica:Array<any>) {
    const srodkowyIndeks = Math.floor(tablica.length / 2);
    
    const pierwszaPolowa = tablica.slice(0, srodkowyIndeks);
    const drugaPolowa = tablica.slice(srodkowyIndeks);
  
    return [pierwszaPolowa, drugaPolowa];
  }
}
